import { accessRole } from "../../../../helpers/access_role";

import React, { Component, Fragment, useState, useRef, useEffect } from "react";
import apiResponse from "../../../../services/apiResponse";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  Alert,
} from "reactstrap";

import Shimmer from "react-shimmer-effect";
import DatePicker from "../../../../helpers/ui/DatePicker";
import moment from "moment";
import classnames from "classnames";
import IndexBloc from "./Blocs/IndexBloc";
import { filter } from "./Data/filter";
import { condition } from "./Data/condition";

import CustomSelect from "../../../../helpers/ui/CustomSelect";

import TableActiveComponent from "./Components/TableActiveComponent";
class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear(),
      month: moment().format("M"),
      is_verif: 1,
      pending_approval_cuti: 1,
      activeTab: "1",
      filterOptions: filter().data,
      selectOptions: [],
      conditionOptions: condition().data,
      filterList: [
        {
          id: 1,
          filter_field: "",
          filter_name: "",
          filter_sort: "",
        },
      ],
      conditionList: [
        {
          id: 1,
          condition_field: "",
          condition_type: "text",
          condition_source: "",
          condition_source_kv: "",
          condition_val: "",
          condition_param_1: "",
          condition_param_2: "",
          condition_flag: "",
        },
      ],

      conditionOptionsOne: [
        {
          flexible_report_condition_icon: "ILIKE",
          flexible_report_condition_id: 8,
          flexible_report_condition_name: "Mengandung",
          flexible_report_condition_status: 1,
        },
      ],

      emp_gender: [{ gender_name: "Laki-laki" }, { gender_name: "Perempuan" }],
    };

    this.activeRef = React.createRef();
  }

  addFilter = () => {
    let count = this.state.filterList.length;
    this.setState({
      filterList: [
        ...this.state.filterList,
        {
          id:
            count == 0 ? count + 1 : this.state.filterList.slice(-1)[0].id + 1,
          filter_field: "",
          filter_name: "",
          filter_sort: "",
        },
      ],
    });

    // console.log(this.state.filterList)
  };

  delFilter = (data) => {
    console.log(data);
    this.setState({
      filterList: [...this.state.filterList.filter((val) => val.id != data.id)],
    });
  };

  handleFilterSelectChange(index, val, mode) {
    // console.log(index, val);
    // 1. Make a shallow copy of the items
    let items = [...this.state.filterList];
    // 2. Make a shallow copy of the item you want to mutate
    let item = { ...items[index] };
    // 3. Replace the property you're intested in
    if (mode == "field") {
      item.filter_field = val.flexible_report_filter_field;
      item.filter_name = val.flexible_report_filter_name;
    }
    if (mode == "sort") {
      item.filter_sort = val.value;
    }
    // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    items[index] = item;
    // 5. Set the state to our new copy
    this.setState({ filterList: items });
  }

  addCondition = () => {
    let count = this.state.conditionList.length;
    this.setState({
      conditionList: [
        ...this.state.conditionList,
        {
          id:
            count == 0
              ? count + 1
              : this.state.conditionList.slice(-1)[0].id + 1,
          condition_field: "",
          condition_type: "text",
          condition_source: "",
          condition_source_kv: "",
          condition_val: "",
          condition_param_1: "",
          condition_param_2: "",
          condition_flag: "",
        },
      ],
    });

    // console.log(this.state.conditionList)
  };

  delCondition = (data) => {
    // console.log(data)
    this.setState({
      conditionList: [
        ...this.state.conditionList.filter((val) => val.id != data.id),
      ],
    });
  };

  handleConditionSelectChange(index, val, mode, optValue = "") {
    // console.log(index, val);
    // 1. Make a shallow copy of the items
    let items = [...this.state.conditionList];
    // 2. Make a shallow copy of the item you want to mutate
    let item = { ...items[index] };
    // 3. Replace the property you're intested in
    if (mode == "field") {
      item.condition_field = val.flexible_report_filter_field;
      item.condition_type = val.flexible_report_filter_type;
      item.condition_source = val.flexible_report_filter_source;
      item.condition_source_kv = val.flexible_report_filter_source_key_value;

      // if select get options data
      if (val.flexible_report_filter_type == "select") {
        this.getFieldSelectOptions(
          val.flexible_report_filter_source,
          val.flexible_report_filter_source_key_value
        );
      }
    }
    if (mode == "val") {
      item.condition_val = val.flexible_report_condition_icon;
      // item.condition_param_1 = "";
      // item.condition_param_2 = "";
    }
    if (mode == "param_1") {
      item.condition_param_1 = val.target.value;
    }
    if (mode == "param_2") {
      item.condition_param_2 = val.target.value;
    }
    if (mode == "param_1_select") {
      item.condition_param_1 = val[optValue];
    }
    if (mode == "param_2_select") {
      item.condition_param_2 = val[optValue];
    }
    // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    items[index] = item;
    // 5. Set the state to our new copy
    this.setState({ conditionList: items });
  }

  getFieldSelectOptions = (source, key_value) => {
    if (!this.state[source]) {
      this.setState({
        loading: true,
      });
      this.indexBloc.fetchMasterOptions({
        source,
        fields: key_value,
      });
    }
  };

  getKeyValueOptions = (source, type) => {
    const arr = source.split(",");
    return type == "key" ? arr[0] : arr[1];
  };

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();

  handleButtonSearch() {
    if (this.validation() == false) {
      return false;
    }
    // console.log(this.state.filterList);
    // this.activeRef.current.generateColumn()
    this.reloadActiveRef();
  }

  handleButtonExport() {
    if (this.validation() == false) {
      return false;
    }
    this.activeRef.current.handleDownloadExcel();
  }

  validation = () => {
    let fields = this.state.filterList;
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].filter_field == "") {
        alert("Terdapat kolom yang belum dipilih, silahkan cek kembali!");
        return false;
      }
      if (fields[i].filter_sort == "") {
        alert("Terdapat urutan yang belum dipilih, silahkan cek kembali!");
        return false;
      }
    }

    let conditions = this.state.conditionList;
    for (let i = 0; i < conditions.length; i++) {
      if (conditions[i].condition_field == "") {
        alert(
          "Terdapat filter kolom yang belum dipilih, silahkan cek kembali!"
        );
        return false;
      }
      if (conditions[i].condition_val == "") {
        alert(
          "Terdapat filter kondisi yang belum dipilih, silahkan cek kembali!"
        );
        return false;
      }
      if (conditions[i].condition_param_1 == "") {
        alert(
          "Terdapat filter parameter yang belum diisi, silahkan cek kembali!"
        );
        return false;
      }
      if (
        conditions[i].condition_val == "BETWEEN" &&
        conditions[i].condition_param_2 == ""
      ) {
        alert(
          "Terdapat filter parameter yang belum diisi, silahkan cek kembali!"
        );
        return false;
      }
    }
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitVerification();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.indexBloc.masterFilterChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          // console.log(response)
          this.setState({
            filterOptions: response.filter,
            selectOptions: response.filter.filter(
              (option) =>
                !["hirarki_deputi", "hirarki_direktur"].includes(
                  option.flexible_report_filter_field
                )
            ),
            conditionOptions: response.condition,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            filterOptions: filter().data,
            conditionOptions: condition().data,
          });
          console.log("fetch filter error, data get from default");
          break;
        default:
          break;
      }
    });
    this.indexBloc.fetchMasterFilter();

    this.indexBloc.masterOptionsChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          // console.log(response)
          this.setState({
            [response.source]: response.result,
            loading: false,
          });
          break;
        case apiResponse.ERROR:
          console.log("fetch options error");
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.masterFilterChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          {/* Tampil Data */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    {/* {
                                        (accessRole('create')) ?
                                            <Link to="home.html?create">
                                                <Button color="primary">New Sample</Button>
                                            </Link>
                                        : null
                                    } */}
                  </div>
                  <CardTitle>Tampilan Data</CardTitle>
                  <CardSubtitle>Pilih Data Yang Akan Ditampilkan</CardSubtitle>
                  <hr />

                  <Row>
                    <Col md="10">
                      <div className="row">
                        <label
                          htmlFor="no_skx"
                          className="col-md-6 col-form-label"
                        >
                          Kolom
                        </label>
                        <label
                          htmlFor="no_skx"
                          className="col-md-4 col-form-label"
                        >
                          Urutan
                        </label>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="10">
                      {this.state.filterList.map((data, index) => {
                        return (
                          <div className="row" key={`in-${index}`}>
                            <div className="col-md-6">
                              <CustomSelect
                                name={`filters[${index}]`}
                                errorMessage="Pilih Filter"
                                options={this.state.selectOptions}
                                // options={this.state.filterOptions.filter(
                                //   (option) =>
                                //     option.flexible_report_filter_field !==
                                //     "hirarki_deputi"
                                // )}
                                optionLabel="flexible_report_filter_name"
                                optionValue="flexible_report_filter_field"
                                placeholder="Pilih Filter"
                                defaultValue={data.filter_field}
                                onChange={(v) =>
                                  this.handleFilterSelectChange(
                                    index,
                                    v,
                                    "field"
                                  )
                                }
                                isAvForm={false}
                              />
                            </div>
                            <div className="col-md-4">
                              <CustomSelect
                                name={`sorts[${index}]`}
                                errorMessage="Pilih Sort"
                                options={[
                                  {
                                    label: "Naik",
                                    value: "ASC",
                                  },
                                  {
                                    label: "Turun",
                                    value: "DESC",
                                  },
                                  {
                                    label: "Tanpa Urutan",
                                    value: "-",
                                  },
                                ]}
                                placeholder="Pilih Sort"
                                defaultValue={data.filter_sort}
                                onChange={(v) =>
                                  this.handleFilterSelectChange(
                                    index,
                                    v,
                                    "sort"
                                  )
                                }
                                isAvForm={false}
                              />
                            </div>
                            <div className="col-md-2 text-right">
                              {index == 0 ? (
                                <div className="col-md-2 text-right">
                                  <Button
                                    className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                    color="success"
                                    type="button"
                                    onClick={this.addFilter}
                                  >
                                    <i className="uil-plus-circle"></i>
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                  color="danger"
                                  type="button"
                                  onClick={() => {
                                    this.delFilter(data);
                                  }}
                                >
                                  <i className="uil-trash-alt"></i>
                                </Button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Filter Data */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    {/* {
                                        (accessRole('create')) ?
                                            <Link to="home.html?create">
                                                <Button color="primary">New Sample</Button>
                                            </Link>
                                        : null
                                    } */}
                  </div>
                  <CardTitle>Fiter Data</CardTitle>
                  <CardSubtitle>Tentukan Data Yang Akan Difilter</CardSubtitle>
                  <hr />

                  <Row>
                    <Col md="12">
                      <div className="row">
                        <label
                          htmlFor="no_skx"
                          className="col-md-3 col-form-label"
                        >
                          Filter Kolom
                        </label>
                        <label
                          htmlFor="no_skx"
                          className="col-md-3 col-form-label"
                        >
                          Kondisi
                        </label>
                        <label
                          htmlFor="no_skx"
                          className="col-md-3 col-form-label"
                        >
                          Parameter
                        </label>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      {this.state.conditionList.map((data, index) => {
                        return (
                          <div className="row" key={`in-${index}`}>
                            <div className="col-md-3">
                              <CustomSelect
                                name={`fields[${index}]`}
                                errorMessage="Pilih Filter"
                                options={this.state.filterOptions}
                                optionLabel="flexible_report_filter_name"
                                optionValue="flexible_report_filter_field"
                                placeholder="Pilih Filter"
                                defaultValue={data.condition_field}
                                onChange={(v) =>
                                  this.handleConditionSelectChange(
                                    index,
                                    v,
                                    "field"
                                  )
                                }
                                isAvForm={false}
                              />
                            </div>

                            <div className="col-md-3">
                              <CustomSelect
                                name={`condition[${index}]`}
                                errorMessage="Pilih Kondisi"
                                options={this.state.conditionOptions}
                                optionLabel="flexible_report_condition_name"
                                optionValue="flexible_report_condition_icon"
                                placeholder="Pilih Kondisi"
                                defaultValue={data.condition_val}
                                onChange={(v) =>
                                  this.handleConditionSelectChange(
                                    index,
                                    v,
                                    "val"
                                  )
                                }
                                isAvForm={false}
                              />
                            </div>

                            <div
                              className={`${
                                data.condition_val == "BETWEEN"
                                  ? "col-md-3 "
                                  : "col-md-5"
                              }`}
                            >
                              {data.condition_type != "select" ? (
                                <Input
                                  name={`condition[${index}]`}
                                  id={`condition_[${index}`}
                                  placeholder="Parameter"
                                  errorMessage="Masukkan Parameter"
                                  type={data.condition_type}
                                  className="form-control"
                                  onChange={(e) => {
                                    this.handleConditionSelectChange(
                                      index,
                                      e,
                                      "param_1"
                                    );
                                  }}
                                  defaultValue={data.condition_param_1}
                                />
                              ) : (
                                <CustomSelect
                                  name={`condition[${index}]`}
                                  errorMessage="Pilih Parameter"
                                  options={this.state[data.condition_source]}
                                  optionLabel={this.getKeyValueOptions(
                                    data.condition_source_kv,
                                    "key"
                                  )}
                                  optionValue={this.getKeyValueOptions(
                                    data.condition_source_kv,
                                    "value"
                                  )}
                                  placeholder="Pilih Parameter"
                                  defaultValue={data.condition_param_1}
                                  onChange={(v) =>
                                    this.handleConditionSelectChange(
                                      index,
                                      v,
                                      "param_1_select",
                                      this.getKeyValueOptions(
                                        data.condition_source_kv,
                                        "value"
                                      )
                                    )
                                  }
                                  isAvForm={false}
                                />
                              )}
                            </div>

                            {data.condition_val == "BETWEEN" && (
                              <div className="col-md-2">
                                {data.condition_type != "select" ? (
                                  <Input
                                    name={`condition2[${index}]`}
                                    id={`condition2_[${index}`}
                                    placeholder="Parameter"
                                    errorMessage="Masukkan Parameter 2"
                                    type={data.condition_type}
                                    className="form-control"
                                    onChange={(e) => {
                                      this.handleConditionSelectChange(
                                        index,
                                        e,
                                        "param_2"
                                      );
                                    }}
                                    defaultValue={data.condition_param_2}
                                  />
                                ) : (
                                  <CustomSelect
                                    name={`condition2[${index}]`}
                                    errorMessage="Pilih Parameter"
                                    options={this.state[data.condition_source]}
                                    optionLabel={this.getKeyValueOptions(
                                      data.condition_source_kv,
                                      "key"
                                    )}
                                    optionValue={this.getKeyValueOptions(
                                      data.condition_source_kv,
                                      "value"
                                    )}
                                    placeholder="Pilih Parameter"
                                    defaultValue={data.condition_param_2}
                                    onChange={(v) =>
                                      this.handleConditionSelectChange(
                                        index,
                                        v,
                                        "param_2_select",
                                        this.getKeyValueOptions(
                                          data.condition_source_kv,
                                          "value"
                                        )
                                      )
                                    }
                                    isAvForm={false}
                                  />
                                )}
                              </div>
                            )}
                            <div className="col-md-1 text-right">
                              {index == 0 ? (
                                <div className="col-md-2 text-right">
                                  <Button
                                    className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                    color="success"
                                    type="button"
                                    onClick={this.addCondition}
                                  >
                                    <i className="uil-plus-circle"></i>
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                  color="danger"
                                  type="button"
                                  onClick={() => {
                                    this.delCondition(data);
                                  }}
                                >
                                  <i className="uil-trash-alt"></i>
                                </Button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Tombol */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    {/* {
                                        (accessRole('create')) ?
                                            <Link to="home.html?create">
                                                <Button color="primary">New Sample</Button>
                                            </Link>
                                        : null
                                    } */}
                  </div>
                  <CardTitle>Aksi</CardTitle>
                  <hr />

                  <Row>
                    <Col md="10">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          this.handleButtonSearch();
                        }}
                      >
                        <i className="uil-refresh"></i> Proses
                      </Button>
                      <Button
                        color="success"
                        type="button"
                        className="ms-2"
                        onClick={() => {
                          this.handleButtonExport();
                        }}
                      >
                        <i className="uil-download-alt"></i> Export
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    {/* {
                                        (accessRole('create')) ?
                                            <Link to="home.html?create">
                                                <Button color="primary">New Sample</Button>
                                            </Link>
                                        : null
                                    } */}
                  </div>
                  <CardTitle>Hasil</CardTitle>
                  <hr />

                  <Row>
                    <Col md="12">
                      <TableActiveComponent
                        ref={this.activeRef}
                        additionalFilter={null}
                        fields={this.state.filterList}
                        filters={this.state.conditionList}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={`Apakah anda yakin akan memverifikasi data presensi pada bulan dan tahun terpilih?`}
          loadingTitle="Mengambil additional data"
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diambil"
          failedTitle="Gagal!"
          failedInfo="Data gagal diambil"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default IndexView;
